import { Link, useLocation } from 'react-router-dom';
import sayitnowLogo from '@/assets/sayitnow-logo.png';
import { cn } from '@/lib/utils';

interface BrandLogoProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  linkTo?: string;
}

const sizeMap = {
  xs: 'h-[56px] w-[56px]',
  sm: 'h-[52px] w-[52px]',
  md: 'h-[64px] w-[64px]',
  lg: 'h-[80px] w-[80px]',
  xl: 'h-[100px] w-[100px]',
};

const textSizeMap = {
  xs: 'text-base',
  sm: 'text-lg',
  md: 'text-xl',
  lg: 'text-3xl',
  xl: 'text-4xl',
};

export function BrandLogo({ size = 'md', className, linkTo = '/' }: BrandLogoProps) {
  const location = useLocation();

  const handleClick = (e: React.MouseEvent) => {
    if (location.pathname === linkTo) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <Link to={linkTo} onClick={handleClick} className={cn('flex items-center gap-1.5 cursor-pointer', className)}>
      <img
        src={sayitnowLogo}
        alt="Say It NOW"
        className={cn(sizeMap[size], 'object-contain drop-shadow-md max-h-none')}
      />
      <div className="flex flex-col leading-none">
        <span className={cn('font-heading font-bold tracking-tight text-foreground', textSizeMap[size])}>
          Say It <span className="text-primary">NOW</span>
        </span>
        <span className="text-[9px] uppercase tracking-[0.2em] text-muted-foreground font-medium">
          Unlock Your Heart
        </span>
      </div>
    </Link>
  );
}
